import { url } from 'inspector';
import { object, string, number, array ,date, InferType } from 'yup';

const DescriptionScheme = object({
    name: string().required().typeError('name is required'),
    description: string()
})

export default DescriptionScheme